import { render, staticRenderFns } from "./brand_products.vue?vue&type=template&id=119c424a&"
import script from "./brand_products.vue?vue&type=script&lang=js&"
export * from "./brand_products.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports